export const PRODUCT_HISTORY = 'PRODUCT_HISTORY'



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-search/store/mutations-types.js